import { Card, Container, Icon, List, Section, Stack } from "@storoey/sui";
import { createFileRoute, useNavigate } from "@tanstack/solid-router";
import { backendService } from "../../../backend/backend.service";
import { SectionBreadcrumbs } from "../../../components/SectionBreadcrumbs/SectionBreadcrumbs";
import { usePageTitle } from "../../../hooks/usePageTitle";

export const Route = createFileRoute("/settings/storage/")({
  loader: async () => {
    return await backendService.getStorageCount();
  },
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Lagring");
  const navigate = useNavigate();

  const loaderData = Route.useLoaderData();

  return (
    <Section
      padding="lg"
      breadcrumbs={
        <SectionBreadcrumbs
          items={[
            { title: "Hjem", path: "/" },
            { title: "Innstillinger", path: "/settings" },
            { title: "Lagring" },
          ]}
        />
      }
    >
      <Container>
        <Stack>
          <Card elevation={200}>
            <Card.Content>
              <Card.Title>Lagring</Card.Title>
              <Card.Text>Oversikt over alle lagrede bilder og opptak</Card.Text>
            </Card.Content>
            <Card.Actions>
              <List>
                <List.Item
                  leading={<Icon>mic</Icon>}
                  trailingText={`${loaderData().recordingCount}`}
                  trailingIcon="chevron_right"
                  onClick={() =>
                    navigate({ to: "/settings/storage/recordings" })
                  }
                >
                  Opptak
                </List.Item>
                <List.Item
                  leading={<Icon>photo</Icon>}
                  trailingText={`${loaderData().photoCount}`}
                  trailingIcon="chevron_right"
                  onClick={() => navigate({ to: "/settings/storage/photos" })}
                >
                  Bilder
                </List.Item>
              </List>
            </Card.Actions>
          </Card>
        </Stack>
      </Container>
    </Section>
  );
}
